<table mat-table [dataSource]="dataSource" matSort>
  <!-- id column -->
  <ng-container matColumnDef="id">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="id" class="w-[165px] whitespace-nowrap">
      {{ translations.number.text }}
    </th>
    <td mat-cell *matCellDef="let row">
      @if (row.value.isNew) {
        <input
          modus-input
          data-cy="classification-number-input"
          type="number"
          [min]="minClassificationId"
          [max]="maxClassificationId"
          [formControl]="row.controls.id"
          [placeholder]="translations.placeholders.number.text"
          (blur)="validateUniqueIds()"
        />
      } @else {
        <span class="ml-2" data-cy="classification-number">{{ row.value.id }}</span>
      }
    </td>
    <td mat-footer-cell *matFooterCellDef>
      @if (showAdd()) {
        <button
          class="text-gray-8"
          modus-icon-button
          data-cy="add-classification-button"
          [modus-tooltip]="translations.add.text"
          [disabled]="disabled()"
          (click)="addNewClassification()"
        >
          <md-icon>add</md-icon>
        </button>
      }
    </td>
  </ng-container>

  <!-- name column -->
  <ng-container matColumnDef="name">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="name">{{ translations.name.text }}</th>
    <td mat-cell *matCellDef="let row">
      <input
        modus-input
        data-cy="classification-name-input"
        [placeholder]="translations.placeholders.name.text"
        [formControl]="row.controls.name"
        (blur)="trimInputValue(row.controls.name)"
      />
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- rgba column -->
  <ng-container matColumnDef="rgba">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="rgba" class="w-[120px]">
      <span class="block text-center">{{ translations.color.text }}</span>
    </th>
    <td mat-cell *matCellDef="let row" class="!overflow-visible">
      <span class="flex w-10 h-5">
        <sd-color-picker
          dialogPosition="bottom-left"
          [formControl]="row.controls.rgba"
        ></sd-color-picker>
      </span>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- visible column -->
  <ng-container matColumnDef="visible">
    <th mat-header-cell *matHeaderCellDef mat-sort-header="visible" class="w-[120px]">
      {{ translations.visibility.text }}
    </th>
    <td mat-cell *matCellDef="let row" class="!text-center">
      <button
        modus-icon-button
        data-cy="classification-visibility-toggle"
        [disabled]="row.disabled"
        (click)="toggleVisibility(row)"
      >
        @if (row.value.visible) {
          <md-icon>visibility_on</md-icon>
        } @else {
          <md-icon>visibility_off</md-icon>
        }
      </button>
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <!-- delete column -->
  <ng-container matColumnDef="delete">
    <th mat-header-cell *matHeaderCellDef class="w-[80px]">{{ translations.delete.text }}</th>
    <td mat-cell *matCellDef="let row" class="!text-center">
      @if (!row.value.predefined) {
        <button
          modus-icon-button
          data-cy="delete-classification-button"
          [disabled]="row.disabled"
          (click)="deleteClassification(row)"
        >
          <md-icon>delete</md-icon>
        </button>
      }
    </td>
    <td mat-footer-cell *matFooterCellDef></td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
</table>
